import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  /// later need to delete
  {
    path: '/adobe-xd',
    redirect: '/user-profile-plugin',
  },
  {
    path: '/adobe-xd/how-to-use',
    redirect: '/user-profile-plugin',
  },
  {
    path: '/user-profile-plugin',
    component: () => import(/* webpackChunkName: "routeView" */ '../views/RouteView.vue'),
    children: [
      {
        path: '',
        name: 'userProfileHome',
        component: () => import(/* webpackChunkName: "userFrameHome" */ '../views/projects/userFrame'),
      },
      {
        path: 'about',
        name: 'About',
        component: () => import(/* webpackChunkName: "userFrameAbout" */ '../views/projects/userFrame/AboutView.vue'),
      },
      {
        path: 'how-to-use',
        name: 'How to use',
        component: () =>
          import(/* webpackChunkName: "userFrameHowToUse" */ '../views/projects/userFrame/HowToUseView.vue'),
      },
      {
        path: 'submit-photo',
        name: 'Submit photo',
        component: () =>
          import(/* webpackChunkName: "userFrameSubmitPhotoView" */ '../views/projects/userFrame/SubmitPhotoView.vue'),
      },
      {
        path: 'beta',
        name: 'Beta Version',
        component: () =>
          import(/* webpackChunkName: "betaVersionView" */ '../views/projects/userFrame/BetaVersionView'),
      },
    ],
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "PageNotFoundView" */ '../views/PageNotFoundView.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
})

export default router
